import { render, staticRenderFns } from "./RegistrarOrdenVentaPago.vue?vue&type=template&id=10d7410f&scoped=true&"
import script from "./RegistrarOrdenVentaPago.vue?vue&type=script&lang=js&"
export * from "./RegistrarOrdenVentaPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d7410f",
  null
  
)

export default component.exports